export default __webpack_public_path__ + "static/media/house-icon.b3c2e070.png";